import { toString, Union } from "../fable_modules/fable-library.3.7.20/Types.js";
import { union_type } from "../fable_modules/fable-library.3.7.20/Reflection.js";
import { singleton, map, ofArray } from "../fable_modules/fable-library.3.7.20/List.js";
import { error } from "../Components/Message/Message.js";
import * as react from "react";
import { view as view_1 } from "./SiteWideMessage.js";
import { render } from "./TelenorErrorReport/View.js";
import { render as render_1 } from "./PayflowPlayground.js";
import { RouterModule_urlSegments, RouterModule_encodeParts } from "../fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { formatUrl } from "../Utils.js";

export class Page extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Default", "SiteWideMessage", "TelenorErrorReport", "PayflowPlayground", "NotFound"];
    }
}

export function Page$reflection() {
    return union_type("Admin.Base.Page", [], Page, () => [[], [], [], [], []]);
}

export const linkablePages = ofArray([new Page(0), new Page(1), new Page(2), new Page(3)]);

function view(page, isAdminUser) {
    let children_6;
    if (!isAdminUser) {
        const children = [error("You do not have the neccessary permissions to view this page.".split(""))];
        return react.createElement("div", {
            className: "p-2",
        }, ...children);
    }
    else {
        let contentHtml;
        switch (page.tag) {
            case 1: {
                contentHtml = view_1;
                break;
            }
            case 2: {
                contentHtml = render();
                break;
            }
            case 3: {
                contentHtml = render_1();
                break;
            }
            case 4: {
                contentHtml = react.createElement("div", {}, "Not found");
                break;
            }
            default: {
                const children_8 = [react.createElement("h2", {}, "Admin"), (children_6 = map((page_1) => {
                    const url = RouterModule_encodeParts(formatUrl(RouterModule_urlSegments(window.location.hash, 1), singleton("Admin"), singleton(toString(page_1))), 1);
                    const children_2 = [toString(page_1)];
                    return react.createElement("a", {
                        href: url,
                        className: "mr-2",
                    }, ...children_2);
                }, linkablePages), react.createElement("ol", {
                    className: "p-0",
                }, ...children_6))];
                contentHtml = react.createElement("div", {}, ...children_8);
            }
        }
        return react.createElement("div", {
            className: "p-2",
        }, contentHtml);
    }
}

export function lazyView(props) {
    return view(props.Page, props.IsAdminUser);
}

